import { render, staticRenderFns } from "./DashboardWarning.vue?vue&type=template&id=65f6fc7e&scoped=true&"
import script from "./DashboardWarning.vue?vue&type=script&lang=js&"
export * from "./DashboardWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6fc7e",
  null
  
)

export default component.exports